<template>
  <dl
    v-if="active"
    class="m-market-row m-market-4"
  >
    <dt class="m-title">
      {{ market.description.split(' ')[0] }}
    </dt>
    <dd
      v-for="outcomeId in market.outcomes.order"
      :key="outcomeId"
    >
      <Outcome
        :outcome="market.outcomes.map[outcomeId]"
        :market="market"
        :event="event"
      />
    </dd>
  </dl>
</template>

<script>
import Outcome from 'wap/match/Event/pagelet/Outcome'

const checkIsActive = (status) => {
  return +status === 0 || +status === 1
}

export default {
  components: {
    Outcome
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    market: {
      type: Object,
      default: () => ({})
    },
    marketTitles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      timer: null,
      active: true
    }
  },
  watch: {
    'market.status'(val) {
      this.timer && clearTimeout(this.timer)
      if (checkIsActive(val)) {
        this.active = true
      } else {
        this.timer = setTimeout(() => {
          this.active = false
        }, 5000)
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss">
.m-market-4 {
  display: block !important;
  flex: 1;
  margin-right: 4px;

  dt {
    margin: -30px 0 4px;
  }

  dd {
    position: relative;
    margin: 0 0 4px;

    .m-outcome {
      width: 100%;
      height: 36px;
    }
  }

  &:last-child {
    margin-right: 0;
  }
}
</style>
